module.exports = __webpack_public_path__ + "static/media/tablet.72be395e.svg";